import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_org/org/bu/$organizationBusinessUnitId/providers/invitations/",
)({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/org/bu/$organizationBusinessUnitId/providers/credentials",
      params,
      replace: true,
    });
  },
});
